import _ from 'lodash/fp'

// import { selectors } from './index' **WAIT FOR THE PROFILE STUFF TO BE HERE
// import { selectors as buddiesSelectors } from './buddies' **WAIT FOR THE PROFILE STUFF TO BE HERE
import { createSelector } from './util'

// weirdo selectors

export const getFlight = (state, { flightId }) => _.get(`matches.flights.items.${flightId}`, state)

export const getFlightGuideId = createSelector(
  getFlight,
  _.get('guideId')
)

export const getFlightGameIds = createSelector(
  getFlight,
  _.get('gameIds')
)

export const getPlayerGames = (state, { playerId }) => _.flow(
  _.get('matches.games.items'),
  _.pickBy((game) => game.userId === playerId)
)(state)

export const makeGetPlayerGameIds = () => createSelector(
  getPlayerGames,
  _.map('gameId')
)
export const getPlayerGameIds = makeGetPlayerGameIds()

export const makeGetPlayerInFlightGameId = () => createSelector(
  getFlightGameIds,
  makeGetPlayerGameIds(),
  (gameIdsForFlight, gameIdsForPlayer) => _.first(_.intersection(gameIdsForFlight, gameIdsForPlayer))
)
export const getPlayerInFlightGameId = makeGetPlayerInFlightGameId()

export const getPageFromGame = (state, { flightId }) => _.getOr(1, `ui.holeViewPages.${flightId}`, state)
export const getGameGuideId = (state, { gameId }) => _.get(`matches.games.items.${gameId}.guideId`, state)
export const getActivePlayerFromFlightId = (state, { flightId }) => _.get(`ui.holeViewUserIds.${flightId}`, state)
export const getGameUserId = (state, { gameId }) => _.get(`matches.games.items.${gameId}.userId`, state)
export const getGameHandicap = (state, { gameId }) => _.get(`matches.games.items.${gameId}.handicap`, state)

export const getGameHolesTees = (state, { gameId }) => _.get(`matches.games.items.${gameId}.holesTees`, state) // { holeId -> { teeId ->, .. }, .. }
export const getDiffsFromGame = (state, { gameId }) => _.getOr(0, `diffs.${gameId}`, state)
export const getHolesHandicapsOrders = (state, { gameId }) => _.get(`matches.games.items.${gameId}.holesHandicapsOrders`, state)

// { holeId -> { shotId ->, .. }, .. }
export const getGameHolesShots = (state, { gameId }) => {
  return _.mapValues.convert({ cap: false })(
    (ignore, holeId) => _.getOr(0, `shots.${gameId}.${holeId}`, state),
    getHolesHandicapsOrders(state, { gameId })
  )
}

export const getActiveHoleId = createSelector(
  getHolesHandicapsOrders,
  getPageFromGame,
  (holesHcpOrder, page) => _.flow(
    _.values,
    _.find(({ holeOrder }) => holeOrder === page),
    _.get('holeId')
  )(holesHcpOrder)
)

export const makeGetGameStrokes = () => createSelector(
  getHolesHandicapsOrders,
  getGameHandicap,
  getGameHolesTees,
  (holesHandicapsOrders, handicap, holesTees) => {
    if (_.isEmpty(holesHandicapsOrders)) {
      console.warn('*** WARNING: holesHandicapsOrders is empty! ***')
      return _.mapValues(_.constant(0), holesTees)
    }

    // begin crazy section

    const numbHoles = _.size(holesTees)

    const strokesEach = handicap >= 0
      ? Math.floor(handicap / numbHoles)
      : Math.ceil(handicap / numbHoles)

    const strokesExcess = Math.ceil(handicap % numbHoles)
    const sortingMultiplier = handicap >= 0 ? 1 : -1

    const holesHandicapsOrdersWithHoleId = _.map.convert({ cap: false })((v, holeId) => ({ ...v, holeId }), holesHandicapsOrders)
    const sortedHolesHandicapsOrders = _.sortBy([(h) => (sortingMultiplier * h.handicap), 'holeOrder'], holesHandicapsOrdersWithHoleId)
    const mapped = _.map.convert({ cap: false })((v, idx) => ({ ...v, handicap: idx + 1 }), sortedHolesHandicapsOrders)
    const grouped = _.keyBy('holeId', mapped)

    return _.mapValues((hoes, holeId) => {
      return strokesEach + (
        hoes.handicap <= strokesExcess
          ? 1
          : hoes.handicap <= Math.abs(strokesExcess) && strokesExcess < 0
            ? -1
            : 0)
    }, grouped)

    // end crazy section
  }
)
export const getGameStrokes = makeGetGameStrokes()

const makeGetGameCountingHolesShots = () => createSelector(
  getGameHolesShots,
  _.mapValues(
    _.flow(
      _.values,
      _.flatten,
      _.reject('deletedAt'),
      _.keyBy('shotId')
    )
  )
)

export const makeGetGameShots = () => createSelector(
  makeGetGameCountingHolesShots(),
  getDiffsFromGame,
  (gameCountingHolesShots, diffs) => _.mapValues.convert({ cap: false })(
    (shots, holeId) => _.flow(
      _.size,
      (storedShots) => storedShots + _.getOr(0, `${holeId}`, diffs)
    )(shots),
    gameCountingHolesShots
  )
)
export const getGameShots = makeGetGameShots()

export const makeGetActiveHoleTotalShots = () => createSelector(
  makeGetGameShots(),
  getActiveHoleId,
  (gameShots, activeHoleId) => _.getOr(0, `${activeHoleId}`, gameShots)
)
export const getActiveHoleTotalShots = makeGetActiveHoleTotalShots()

export const makeGetGameTotalShots = () => createSelector(
  makeGetGameShots(),
  _.flow(
    _.values,
    _.sum
  )
)
export const getGameTotalShots = makeGetGameTotalShots()

export const makeGetGamePoints = () => createSelector(
  makeGetGameShots(),
  getHolesHandicapsOrders,
  makeGetGameStrokes(),
  (gameShots, holesHandicapsOrders, gameStrokes) => _.flow(
    _.mapValues.convert({ cap: false })((strokes, holeId) => {
      const shots = _.getOr(0, `${holeId}`, gameShots)

      return shots === 0
        ? 0
        : Math.max((_.get(`${holeId}.par`, holesHandicapsOrders) + strokes + 2 - shots), 0)
    })
  )(gameStrokes)
)
export const getGamePoints = makeGetGamePoints()

export const makeGetGameTotalPoints = () => createSelector(
  makeGetGamePoints(),
  _.flow(
    _.values,
    _.sum
  )
)
export const getGameTotalPoints = makeGetGameTotalPoints()

export const makeGetHoleInfo = () => createSelector(
  getHolesHandicapsOrders,
  getPageFromGame,
  (holesHcpOrder, page) => {
    return {
      holesHcpOrder,
      page
    }
  }
)
export const getHoleInfo = makeGetHoleInfo()

/* export const makeGetGamePlayer = () => createSelector( **WAIT FOR THE PROFILE STUFF TO BE HERE
  getGameUserId,
  getGameHandicap,
  selectors.profile.getProfileUser,
  selectors.ghostUsers.getAll,
  buddiesSelectors.getBuddies,
  (id, shcp, profileUser, ghostUsers, buddies) => {
    if (_.find(['id', id], ghostUsers)) {
      return {
        id,
        shcp,
        ..._.find(['id', id], ghostUsers)
      }
    }
    if (_.has(id, buddies)) {
      return {
        shcp,
        ..._.get(id, buddies)
      }
    }
    return {
      id,
      shcp,
      ...profileUser
    }
  }
) */
// export const getGamePlayer = makeGetGamePlayer()
